import { createContext } from 'react';

// Pages the Page Library lists, keyed by getPageKey, mapped to their detail view. Any other page keeps the
// in-page editor.
export const PageEditUrlsContext = createContext<Record<string, string> | null>(null);
